	import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface Win32_ProcessorEntryJsonWrapper {
//    win32_processor_entry: Win32_ProcessorEntryJson;
//}

//export interface Win32_ProcessorEntryJson {
//    device_id: string;
//    caption: string;
//    name: string;
//    address_width: string;
//    architecture: string;
//    cpu_status: string;
//    data_width: string;
//    description: string;
//    family: string;
//    l2_cache_size: string;
//    l2_cache_speed: string;
//    l3_cache_size: string;
//    l3_cache_speed: string;
//    load_percentage: string;
//    manufacturer: string;
//    number_of_cores: string;
//    number_of_logical_processors: string;
//    processor_id: string;
//}

export class Win32_ProcessorEntry implements ObjectSerializer {
    //public static FromJson(json: Win32_ProcessorEntryJson): Win32_ProcessorEntry {

    //    var result = new Win32_ProcessorEntry();

    //    if (json.device_id !== undefined) {
    //        result.DeviceID = json.device_id;
    //    }
    //    if (json.caption !== undefined) {
    //        result.Caption = json.caption;
    //    }
    //    if (json.name !== undefined) {
    //        result.Name = json.name;
    //    }
    //    if (json.description !== undefined) {
    //        result.Description = json.description;
    //    }
    //    if (json.address_width !== undefined) {
    //        result.AddressWidth = NumberUtils.ToNumber(json.address_width);
    //    }
    //    if (json.architecture !== undefined) {
    //        result.Architecture = NumberUtils.ToNumber(json.architecture);
    //    }
    //    if (json.cpu_status !== undefined) {
    //        result.CpuStatus = NumberUtils.ToNumber(json.cpu_status);
    //    }
    //    if (json.data_width !== undefined) {
    //        result.DataWidth = NumberUtils.ToNumber(json.data_width);
    //    }
    //    if (json.family !== undefined) {
    //        result.Family = NumberUtils.ToNumber(json.family);
    //    }
    //    if (json.l2_cache_size !== undefined) {
    //        result.L2CacheSize = NumberUtils.ToNumber(json.l2_cache_size);
    //    }
    //    if (json.l2_cache_speed !== undefined) {
    //        result.L2CacheSpeed = NumberUtils.ToNumber(json.l2_cache_speed);
    //    }
    //    if (json.l3_cache_size !== undefined) {
    //        result.L3CacheSize = NumberUtils.ToNumber(json.l3_cache_size);
    //    }
    //    if (json.l3_cache_speed !== undefined) {
    //        result.L3CacheSpeed = NumberUtils.ToNumber(json.l3_cache_speed);
    //    }
    //    if (json.load_percentage !== undefined) {
    //        result.LoadPercentage = NumberUtils.ToNumber(json.load_percentage);
    //    }
    //    if (json.manufacturer !== undefined) {
    //        result.Manufacturer = json.manufacturer;
    //    }
    //    if (json.number_of_cores !== undefined) {
    //        result.NumberOfCores = NumberUtils.ToNumber(json.number_of_cores);
    //    }
    //    if (json.number_of_logical_processors !== undefined) {
    //        result.NumberOfLogicalProcessors = NumberUtils.ToNumber(json.number_of_logical_processors);
    //    }
    //    if (json.processor_id !== undefined) {
    //        result.ProcessorID = json.processor_id;
    //    }

    //    return result;
    //}

    public DeviceID: string;
    public get HasDeviceID() {
        return !!this.DeviceID;
    }

    public Name: string;
    public get HasName() {
        return !!this.Name;
    }

    public Caption: string;
    public get HasCaption() {
        return !!this.Caption;
    }

    public Description: string;
    public get HasDescription() {
        return !!this.Description;
    }

    public AddressWidth: number;
    public get HasAddressWidth() {
        return this.AddressWidth >= 0;
    }

    public Architecture: number;
    public get HasArchitecture() {
        return this.Architecture >= 0;
    }

    public CpuStatus: number;
    public get HasCpuStatus() {
        return this.CpuStatus >= 0;
    }

    public DataWidth: number;
    public get HasDataWidth() {
        return this.DataWidth >= 0;
    }

    public Family: number;
    public get HasFamily() {
        return this.Family >= 0;
    }

    public InstallDate: number;
	public get HasInstallDate() {
		return (!!this.InstallDate && this.InstallDate > 0);
    }

    public L2CacheSize: number;
    public get HasL2CacheSize() {
        return this.L2CacheSize >= 0;
    }

    public L2CacheSpeed: number;
    public get HasL2CacheSpeed() {
        return this.L2CacheSpeed >= 0;
    }

    public L3CacheSize: number;
    public get HasL3CacheSize() {
        return this.L3CacheSize >= 0;
    }

    public L3CacheSpeed: number;
    public get HasL3CacheSpeed() {
        return this.L3CacheSpeed >= 0;
    }

    public LoadPercentage: number;
    public get HasLoadPercentage() {
        return this.LoadPercentage >= 0;
    }

    public Manufacturer: string;
    public get HasManufacturer() {
        return !!this.Manufacturer;
    }

    public NumberOfCores: number;
    public get HasNumberOfCores() {
        return this.NumberOfCores >= 0;
    }

    public NumberOfLogicalProcessors: number;
    public get HasNumberOfLogicalProcessors() {
        return this.NumberOfLogicalProcessors >= 0;
    }

    public ProcessorID: string;
    public get HasProcessorID() {
        return !!this.ProcessorID;
    }

    public UniqueID: string;
    public get HasUniqueID() {
        return !!this.UniqueID;
    }

    public Version: string;
    public get HasVersion() {
        return !!this.Version;
    }

    constructor() {
        this.DeviceID = "";
        this.Name = "";
        this.Caption = '';
        this.Description = '';

        this.AddressWidth = -1;
        this.Architecture = -1;
        this.CpuStatus = -1;
        this.DataWidth = -1;
        this.Family = -1;

        this.L2CacheSize = -1;
        this.L2CacheSpeed = -1;
        this.L3CacheSize = -1;
        this.L3CacheSpeed = -1;

        this.LoadPercentage = -1;

        this.Manufacturer = "";

        this.NumberOfCores = -1;
        this.NumberOfLogicalProcessors = -1;

        this.ProcessorID = "";
        this.UniqueID = "";
        this.Version = "";
    }

	public Write(obj: any, context: any): void {
		obj.win32_processor_entry = {};
		obj = obj.win32_processor_entry;

		if (this.HasDeviceID)
			obj.device_id = this.DeviceID;
		if (this.HasUniqueID)
			obj.unique_id = this.UniqueID;
		if (this.HasName)
			obj.name = this.Name;
		if (this.HasAddressWidth)
			obj.address_width = ValueEncoder.EncodeInteger(this.AddressWidth);
		if (this.HasArchitecture)
			obj.architecture = ValueEncoder.EncodeInteger(this.Architecture);
		if (this.HasCaption)
			obj.caption = this.Caption;
		if (this.HasCpuStatus)
			obj.cpu_status = ValueEncoder.EncodeInteger(this.CpuStatus);
		if (this.HasDataWidth)
			obj.data_width = ValueEncoder.EncodeInteger(this.DataWidth);
		if (this.HasDescription)
			obj.description = this.Description;
		if (this.HasFamily)
			obj.family = ValueEncoder.EncodeInteger(this.Family);
		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);
		if (this.HasL2CacheSize)
			obj.l2_cache_size = ValueEncoder.EncodeInteger(this.L2CacheSize);
		if (this.HasL2CacheSpeed)
			obj.l2_cache_speed = ValueEncoder.EncodeInteger(this.L2CacheSpeed);
		if (this.HasL3CacheSize)
			obj.l3_cache_size = ValueEncoder.EncodeInteger(this.L3CacheSize);
		if (this.HasL3CacheSpeed)
			obj.l3_cache_speed = ValueEncoder.EncodeInteger(this.L3CacheSpeed);
		if (this.HasLoadPercentage)
			obj.load_percentage = ValueEncoder.EncodeInteger(this.LoadPercentage);
		if (this.HasManufacturer)
			obj.manufacturer = this.Manufacturer;
		if (this.HasNumberOfCores)
			obj.number_of_cores = ValueEncoder.EncodeInteger(this.NumberOfCores);
		if (this.HasNumberOfLogicalProcessors)
			obj.number_of_logical_processors = ValueEncoder.EncodeInteger(this.NumberOfLogicalProcessors);
		if (this.HasProcessorID)
			obj.processor_id = this.ProcessorID;
		if (this.HasUniqueID)
			obj.unique_id = this.UniqueID;
		if (this.HasVersion)
			obj.version = this.Version;
	}


	public Read(obj: any, context: any): void {
		if (!obj.win32_processor_entry)
			throw new Error();
		obj = obj.win32_processor_entry;
		
		if (obj.device_id !== undefined)
			this.DeviceID = obj.device_id;
		if (obj.unique_id !== undefined)
			this.UniqueID = obj.unique_id;
		if (obj.name !== undefined)
			this.Name = obj.name;
		if (obj.address_width !== undefined)
			this.AddressWidth = ValueEncoder.DecodeInteger(obj.address_width);
		if (obj.architecture !== undefined) 
			this.Architecture = ValueEncoder.DecodeInteger(obj.architecture);
		if (obj.caption !== undefined)
			this.Caption = obj.caption;
		if (obj.cpu_status !== undefined)
			this.CpuStatus = ValueEncoder.DecodeInteger(obj.cpu_status);
		if (obj.data_width !== undefined)
			this.DataWidth = ValueEncoder.DecodeInteger(obj.data_width);
		if (obj.description !== undefined)
			this.Description = obj.description;
		if (obj.family !== undefined)
			this.Family = ValueEncoder.DecodeInteger(obj.family);
		if (obj.install_date !== undefined)
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);
		if (obj.l2_cache_size !== undefined)
			this.L2CacheSize = ValueEncoder.DecodeInteger(obj.l2_cache_size);
		if (obj.l2_cache_speed !== undefined)
			this.L2CacheSpeed = ValueEncoder.DecodeInteger(obj.l2_cache_speed);
		if (obj.l3_cache_size !== undefined)
			this.L3CacheSize = ValueEncoder.DecodeInteger(obj.l3_cache_size);
		if (obj.l3_cache_speed !== undefined)
			this.L3CacheSpeed = ValueEncoder.DecodeInteger(obj.l3_cache_speed);
		if (obj.load_percentage !== undefined)
			this.LoadPercentage = ValueEncoder.DecodeInteger(obj.load_percentage);
		if (obj.manufacturer !== undefined)
			this.Manufacturer = obj.manufacturer;
		if (obj.number_of_cores !== undefined)
			this.NumberOfCores = ValueEncoder.DecodeInteger(obj.number_of_cores);
		if (obj.number_of_logical_processors !== undefined)
			this.NumberOfLogicalProcessors = ValueEncoder.DecodeInteger(obj.number_of_logical_processors);
		if (obj.processor_id !== undefined)
			this.ProcessorID = obj.processor_id;
		if (obj.unique_id !== undefined)
			this.UniqueID = obj.unique_id;
		if (obj.version !== undefined)
			this.Version = obj.version;
	}
}


export class Win32_ProcessorTable extends InfoSet
{
    //public static FromJson(json: InfoSetEntriesJson<Win32_ProcessorEntryJsonWrapper>, device: Device): Win32_ProcessorTable {

    //    var result = new Win32_ProcessorTable(device);

    //    json.entries.forEach((jsonEntry) => {
    //        var entry = Win32_ProcessorEntry.FromJson(jsonEntry.win32_processor_entry);
    //        result.AddProcessor(entry);
    //    });

    //    return result;
    //}

    private _processorTable: Dictionary<string, Win32_ProcessorEntry>;

	constructor(device: Device) {
		super(device);
        this._processorTable = new Dictionary<string, Win32_ProcessorEntry>();
		return;
	}

    public Add(deviceID: string): Win32_ProcessorEntry {
        var processorEntry: Win32_ProcessorEntry = this.Find(deviceID);

        if (!processorEntry) {
            processorEntry = new Win32_ProcessorEntry();
            this.AddProcessor(processorEntry);
		}

        return processorEntry;
	}

    public AddProcessor(processorEntry: Win32_ProcessorEntry): boolean {
        if (!processorEntry.HasDeviceID)
            return false;

        if (!this._processorTable.ContainsKey(processorEntry.DeviceID)) {
            this._processorTable.Add(processorEntry.DeviceID, processorEntry);
			return true;
		}

		return false;
	}

	public Clear():void {
		this._processorTable.Clear();
	}

	public get Count(): number {
		return this._processorTable.Count;
	}

    public Find(deviceID: string): Win32_ProcessorEntry {
		return this._processorTable.Item(deviceID);
	}

    public Remove(deviceID: string): boolean {
        return this._processorTable.Remove(deviceID);
	}

    public ForEach(callbackfn: (value: Win32_ProcessorEntry, index: number, array: Win32_ProcessorEntry[]) => void, thisArg?: any): void {
		this._processorTable.Values().ForEach(callbackfn, thisArg);
	}

    public Some(callbackfn: (value: Win32_ProcessorEntry, index: number, array: Win32_ProcessorEntry[]) => boolean, thisArg?: any): boolean {
        return this._processorTable.Values().Some(callbackfn, thisArg);
	}

    public Every(callbackfn: (value: Win32_ProcessorEntry, index: number, array: Win32_ProcessorEntry[]) => boolean, thisArg?: any): boolean {
        return this._processorTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		if (this._processorTable.Count > 0) {
			obj.w32_proc_info = {};
			obj = obj.w32_proc_info;

			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this._processorTable.Values(), context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_proc_info)
			throw new Error();
		obj = obj.w32_proc_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new Win32_ProcessorEntry();
				entry.Read(value, context);
				this.AddProcessor(entry);
			}, this);
		}
	}
}
